'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSelectedVertical = exports.getDefaultVerticalId = exports.initializeMultiSelectFromHash = exports.selectSearchFilters = exports.selectSearchFilterWriteActions = exports.makeWriteFilterSetSelector = exports.searchFilterActions = undefined;

var _filterSets = require('constants/filter-sets');

var _filtersets = require('redux/modules/filtersets');

var _user = require('redux/modules/user');

var _selectors = require('redux/saga/selectors');

var _deep = require('helpers/deep');

var _Search = require('../Search.constants');

var searchFilterActions = exports.searchFilterActions = (0, _filtersets.actionsForFilterSet)(_filterSets.SEARCH);

var makeWriteFilterSetSelector = exports.makeWriteFilterSetSelector = function makeWriteFilterSetSelector(filterSet) {
  return function (action) {
    return _filtersets.FILTER_WRITE_ACTIONS.includes(action.type) && (0, _deep.deepExtract)('data.filterSetId', action) === filterSet && !(0, _deep.deepExtract)('data.excludeFromWriteActions', action);
  };
};

var selectSearchFilterWriteActions = exports.selectSearchFilterWriteActions = makeWriteFilterSetSelector(_filterSets.SEARCH);
var selectSearchFilters = exports.selectSearchFilters = function selectSearchFilters(state) {
  return (0, _selectors.filterSetFilters)(state, _filterSets.SEARCH);
};

var initializeMultiSelectFromHash = exports.initializeMultiSelectFromHash = function initializeMultiSelectFromHash(keys, filtersFromHash) {
  return (
    // Due to the way multi-select filters are implemented in store, we can only include keys that are filtered
    keys.reduce(function (acc, amenityKey) {
      if (filtersFromHash[amenityKey]) {
        if (!acc) {
          acc = {};
        }
        acc[amenityKey] = true;
      }
      return acc;
    }, null)
  );
};

var getDefaultVerticalId = exports.getDefaultVerticalId = function getDefaultVerticalId(state) {
  var isUserLoggedIn = (0, _user.isLoggedIn)(state);

  return !isUserLoggedIn ? _Search.VERTICALS.all : _Search.VERTICALS.fitness;
};

var selectSelectedVertical = exports.selectSelectedVertical = function selectSelectedVertical(state) {
  var selectedVerticalId = (0, _deep.deepExtract)('verticals.value', (0, _selectors.filterSetFilters)(state, _filterSets.SEARCH));
  return selectedVerticalId || getDefaultVerticalId(state);
};